import { makeStyles } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

const colorHeight = '42px';

export const useCardTextOnlyLayoutStyles = makeStyles({
  topColor: {
    height: colorHeight,
    width: '100%',
    borderTopRightRadius: customTokens.borderRadiusMedium,
    borderTopLeftRadius: customTokens.borderRadiusMedium,
  },
  icon: {
    width: customTokens.spacingHorizontal8XL,
  },
});
